module.exports = __webpack_public_path__ + "img/down.52614923.svg";